var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon bill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 43",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 32",
    d: "M-246-186v-22h10v.005l4.988 4.995h.012v17zm1-1h13v-15h-5v-5h-8zm9-16h3.575l-3.575-3.58zm-2 14v-1h4v1zm-5-3v-1h9v1zm0-3v-1h9v1zm0-3v-1h9v1zm.416-4.163H-243l.155-.32h.215a.955.955 0 0 1 0-.113 1.04 1.04 0 0 1 0-.119h-.343l.156-.32h.238a1.5 1.5 0 0 1 1.516-1.16 1.654 1.654 0 0 1 1.009.32l-.3.585a1.072 1.072 0 0 0-.721-.266.864.864 0 0 0-.841.521h1.416l-.169.32h-1.324a1 1 0 0 0 0 .119.918.918 0 0 0 0 .113h1.2l-.164.32h-.955a.861.861 0 0 0 .841.525 1.058 1.058 0 0 0 .721-.269l.3.589a1.654 1.654 0 0 1-1.009.319 1.511 1.511 0 0 1-1.525-1.164z",
    transform: "translate(251 209)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBill);
export default __webpack_public_path__ + "static/media/iconBill.52e0c86d831aeb320e5764ba12920d00.svg";
export { ForwardRef as ReactComponent };